import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: match[1] });
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: res.data }, replace: true });
      } catch (e) {
        console.error("Session exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="h-screen flex items-center justify-center bg-white">
      <div className="text-zinc-500 text-sm tracking-wide">Signing you in…</div>
    </div>
  );
}
